module.exports = __webpack_public_path__ + "static/media/linkedin.85639e01.svg";